import BasicButton, { HoverBasicButton } from 'components/Buttons/BasicButton';
import { ViewDetailDiagnosisPageInfoBody } from 'components/Hospital/ViewDetailInfoBody';
import { pagePaths } from 'constants/path';
import {
    consultationTaps,
    diagnosisTaps,
    leaveModalText,
    programList,
    returnSelectedAssessmentModalText,
    viewDetailConsultationPageText,
    viewDetailDiagnosisPageText,
} from 'constants/viewDetailDiagnosisPageConstants';
import { formattedTime } from 'utils/calculateTime';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoginStore } from 'store/useLoginDataStore';
import styled from 'styled-components';
import { ColumnDivider, FlexWrapper, PageTitle } from 'styles/Global/commonStyles';
import { font, palette } from 'styles/Global/globalStyles';
import {
    DetailPageInfoLayout,
    DiagnosisInnerLayout,
    DiagnosisItemButton,
    DiagnosisLayout,
    DiagnosisTapsContainer,
    HospitalPageLabel,
    InfoHeaderButtonContainer,
    InfoHeaderContainer,
    TapsButtonContainer,
    TwoBreadCrumbContainer,
} from 'styles/Global/hospitalStyles';
import { InfoBodyUserResponsesProps } from 'models/Hospital/viewDetailDiagnosisPageTypes';
import useToggle from 'hooks/CustomHooks/useToggle';
import AddAssessmentModal from 'components/Modal/AddAssessmentModal';
import EditDiagnosisInfoModal from 'components/Modal/EditDiagnosisInfoModal';
import { highSchool, middleSchool, primarySchool, schoolAge as schoolName } from 'constants/schoolAgeAndSemester';
import moment from 'moment';
import { useLeaveModalStateStore } from 'store/useLeaveModalStateStore';
import LeaveModal from 'components/Modal/LeaveModal';
import EditPatientInfoModal from 'components/Modal/EditPatientInfoModal';
import { calculateAge, calculateDaysLived } from 'utils/calculateAge';
import { isValidBirthdate } from 'utils/validationFunctions';
import RemoveDiagnosisModal from 'components/Modal/RemoveDiagnosisModal';
import InfoBodyAssessmentList from './InfoBodyAssessmentList';
import InfoBodyComprehensiveResults from './InfoBodyComprehensiveResults';
import InfoBodyDiagnosisMemo from './InfoBodyDiagnosisMemo';
import DiagnosisMemoCancelConfirmModal from 'components/Modal/DiagnosisMemoCancelConfirmModal';
import _ from 'lodash';
import InfoBodyUserResponses from './InfoBodyUserResponses';
import ArrowRightSlim from 'assets/Icons/Arrow/ArrowRightSlim';
import useConnectRtdb from 'hooks/FirebaseHooks/useConnectRtdb';
import { useLoadingStore } from 'store/useLoadingStore';
import assessmentsFilter from 'functions/assessmentsFilter';
import { AccountLevel, DiagnosisStatus } from 'utils/statusCode';
import { editReportTags } from './utils';
import { getCancelMemoText, getConsultationTypeStr, getRelationTypeStr } from 'utils/hospitalUtils';
import BasicConfirmModal from 'components/Modal/BasicConfirmModal';
import { DescToolTip } from 'components/ToolTip/UserLevelInfoToolTip';
import ProfileDetailInfoWithInput from 'components/Modal/ProfileDetailInfoWithInput';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { Body2Medium, Body2SemiBold, Body4Medium } from 'styles/Global/typography';
import { changeMobileForm } from 'utils/changeMobileForm';
import { DiagnosisUpdateReqeustType, GetResultDiagnosisApiResponse } from 'models/DCK/DCKApiTypes';
import useDiagnosisUpdateMutation from 'api/Mutations/Diagnosis/useDiagnosisUpdateMutation';
import usePatientUpdateMutation from 'api/Mutations/Patient/usePatientUpdateMutation';
import { useClearDiagnosisMutation } from 'api/Mutations/Diagnosis/useClearDiagnosisMutate';
import { usePatientFindByIdQuery } from 'api/Queries/Patient/usePatientFindByIdQuery';
import { TextColor } from 'styles/Global/colorSemantic';
import { IDAssessment, IDDiagnosis, IDPatient } from 'models/DCK/basicInterface';
import useDiagnosisChangeStatusMutation from 'api/Mutations/Diagnosis/useDiagnosisChangeStatusMutation';
import { getDiagnosisStatus, getNoShowModalContent } from '../utils';
import { useDialogueScheduleHooks } from 'hooks/CustomHooks/useDialogueScheduleHooks';
import FillOutDialogueSchedule from 'components/DesignSystem/Modal/FillOutDialogueSchedule';
import { useDiagnosisFindByIdQuery } from 'api/Queries/Diagnosis/useDiagnosisFindByIdQuery';
import { useGetResultByDiagnosisIdQuery } from 'api/Queries/Assessment/useGetResultByDiagnosisIdQuery';
import { useGetAssessmentListQuery } from 'api/Queries/Assessment/useGetAssessmentListQuery';
import useUpdateNoShowInfoMutation from 'api/Mutations/Diagnosis/useUpdateNoShowInfoMutate';
import { DCKDiagnosisApi } from 'api/DCK/DCKDiagnosisApi';
import { DCKAssessmentApi } from 'api/DCK/DCKAssessmentApi';

const ViewDetailDiagnosisPage = () => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const { loginData, setLoginData } = useLoginStore();

    const [patientInfoInitData, setPatientInfoInitData] = useState<IDPatient>(settingInitPatientInfo);
    const [patientName, setPatientName] = useState(patientInfoInitData.name);
    const [identityNumber, setIdentityNumber] = useState(patientInfoInitData.identityNumber.slice(0, 6));
    const [gender, setGender] = useState(patientInfoInitData.identityNumber.slice(6, 7));
    const [mobileNumber, setMobileNumber] = useState(patientInfoInitData.mobile);
    const [patientMemo, setPatientMemo] = useState(patientInfoInitData.patientMemo);
    const [patientCode, setPatientCode] = useState(patientInfoInitData.patientCode);
    const [birthDate, setBirthDate] = useState('');
    const [age, setAge] = useState('');
    const [identityNumberError, setIdentityNumberError] = useState('');
    const [mobileNumberError, setMobileNumberError] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [editDiagnosisModalButtonDisabled, setEditDiagnosisModalButtonDisabled] = useState(false);
    const [diagnosisInfoData, setDiagnosisInfoData] = useState<IDDiagnosis>(state);
    const [initAssessmentData, setInitAssessmentData] = useState<IDAssessment[]>([]);
    const [filterAssessmentData, setFilterAssessmentData] = useState<IDAssessment[]>([]);
    const [otherAssessmentData, setOtherAssessmentData] = useState<IDAssessment[]>([]);
    const [temporarySelectedTap, setTemporarySelectedTap] = useState(loginData.diagnosisTap);
    const [selectedTLCProgram, setSelectedTLCProgram] = useState(0);
    const [initSelectedAssessment, setInitSelectedAssessment] = useState<IDAssessment[]>([]);
    const [selectedAssessment, setSelectedAssessment] = useState<IDAssessment[]>([]);
    const [allCheck, setAllCheck] = useState(false);
    const [allFilterAssessmentCheck, setAllFilterAssessmentCheck] = useState(false);
    const [allOtherAssessmentCheck, setAllOtherAssessmentCheck] = useState(false);
    const [schoolAge, setSchoolAge] = useState('');
    const [semester, setSemester] = useState('');
    const [gradeCode, setGradeCode] = useState('');
    const [schoolAgeIdx, setSchoolAgeIdx] = useState<number>();
    const [semesterIdx, setSemesterIdx] = useState<number>();
    const [onSchoolAgeDropdown, setOnSchoolAgeDropdown] = useState(false);
    const [onSemesterDropdown, setOnSemesterDropdown] = useState(false);
    const [onCalendar, setOnCalendar] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState<string>('');
    const [doctorsIdx, setDoctorsIdx] = useState<number>();
    const [errMsg, setErrMsg] = useState({ schoolAge: '', semester: '' });
    const [infoBodyComprehensiveResultsSelectedIdx, setInfoBodyComprehensiveResultsSelectedIdx] = useState(0);
    const [infoBodyUserResponsesSelectedIdx, setInfoBodyUserResponsesSelectedIdx] = useState(0);
    const [comprehensiveResults, setComprehensiveResults] = useState<GetResultDiagnosisApiResponse['data']>();
    const [diagnosisMemo, setDiagnosisMemo] = useState('');
    const [initDiagnosisMemo, setInitDiagnosisMemo] = useState('');
    const [counselReason, setCounselReason] = useState('');
    const [memoChangeBtn, setMemoChangeBtn] = useState(false);
    const [findByAssessmentCode, setFindByAssessmentCode] = useState<InfoBodyUserResponsesProps['findByAssessmentCode']>([]);
    const [openTaps, setOpenTaps] = useState(false);

    const { loading, setLoading } = useLoadingStore();

    const [isAddAssessmentModal, setIsAddAssessmentModal] = useToggle();
    const [isEditDiagnosisInfoModal, setIsEditDiagnosisInfoModal] = useToggle();
    const [isChangePatientInfoModal, setIsChangePatientInfoModal] = useToggle();
    const [isRemoveDiagnosisModal, setIsRemoveDiagnosisModal] = useToggle();
    const [isCancelMemoModal, setIsCancelMemoModal] = useToggle();
    const [isCompleteCounselingModal, setIsCompleteCounselingModal] = useToggle();
    const [isNoShowDesc, setIsNoShowDesc] = useToggle();
    const [isChangeCounselDateDesc, setIsChangeCounselDateDesc] = useToggle();
    const [checkedCall, setCheckedCall] = useToggle();
    const [onProfileModal, setOnProfileModal] = useToggle();
    const {
        selectedDate,
        setSelectedDate,
        selectedTime,
        setSelectedTime,
        selectedDialogueScheduleData,
        onDialogueScheduleModal,
        initDate,
        onChangeDiagnosisDateModal,
        closeFillOutDialogueScheduleModal,
        getRqDataUpdateDiagnosisInfo,
    } = useDialogueScheduleHooks();

    const {
        editState,
        setEditState,
        movePath,
        clickType,
        setClickType,
        setInit,
        isLeaveModal,
        setIsLeaveModal,
        returnSelectedAssessmentState,
        isReturnSelectedAssessment,
        setReturnSelectedAssessmentState,
        setIsReturnSelectedAssessment,
    } = useLeaveModalStateStore();

    const sortedData = useConnectRtdb();

    const { mutate: updateNoShowInfo } = useUpdateNoShowInfoMutation();
    const { mutate: diagnosisUpdate } = useDiagnosisUpdateMutation();
    const { mutate: diagnosisChangeStatus } = useDiagnosisChangeStatusMutation();
    const { mutate: patientUpdate } = usePatientUpdateMutation();
    const { mutateAsync: clearDiagnosis } = useClearDiagnosisMutation();
    const { data: patientData, refetch: refetchPatientData } = usePatientFindByIdQuery(state.patientId);
    const { data: diagnosisData, refetch: refetchDiagnosisData } = useDiagnosisFindByIdQuery(diagnosisInfoData._id, patientData);
    const { data: resultDiagnosis, refetch: refetchResultDiagnosis } = useGetResultByDiagnosisIdQuery(diagnosisInfoData._id);
    const { data: assessmentList, refetch: refetchAssessmentList } = useGetAssessmentListQuery();

    const hospitalSelectedTaps = loginData.level === AccountLevel.externalCounselor ? consultationTaps : diagnosisTaps;

    // rendering 시 환자 정보, 검사 목록 불러오기
    useEffect(() => {
        processPatientData();

        return () => setLoginData({ ...loginData, diagnosisTap: 0 });
    }, [patientData]);

    useEffect(() => {
        processDiagnosisData();
        processResultDiagnosis();

        const open = _.some(diagnosisInfoData.assessmentList, (item) => item.status === 2);
        if (open) {
            return setOpenTaps(_.some(diagnosisInfoData.assessmentList, (item) => item.status === 2));
        }

        return setOpenTaps(false);
    }, [diagnosisData, _.find(sortedData, { _id: diagnosisData?._id })?.assessmentList]);

    // 각각 check box의 선택에 따른 전체 선택 체크 및 페이지 나가기 모달 조건 구현
    useEffect(() => {
        if (diagnosisInfoData.status === DiagnosisStatus.notAssigned && selectedAssessment.length !== 0) {
            setReturnSelectedAssessmentState(true);
        } else if (diagnosisInfoData.status === DiagnosisStatus.notAssigned && selectedAssessment.length === 0) {
            setReturnSelectedAssessmentState(false);
        }

        if (filterAssessmentData.every((item) => selectedAssessment.includes(item))) {
            setAllFilterAssessmentCheck(true);
        } else {
            setAllFilterAssessmentCheck(false);
        }

        if (otherAssessmentData.every((item) => selectedAssessment.includes(item))) {
            setAllOtherAssessmentCheck(true);
        } else {
            setAllOtherAssessmentCheck(false);
        }

        if (selectedAssessment.length === filterAssessmentData?.length + otherAssessmentData?.length) {
            setAllCheck(true);
        } else {
            setAllCheck(false);
        }
    }, [selectedAssessment, filterAssessmentData, diagnosisInfoData, otherAssessmentData]);

    // 버튼 비활성화 로직
    useEffect(() => {
        if (identityNumberError || mobileNumberError || !patientName || !identityNumber || !gender || !mobileNumber) {
            return setButtonDisabled(true);
        } else if (
            patientName === patientInfoInitData.name &&
            identityNumber === patientInfoInitData.identityNumber.slice(0, 6) &&
            gender === patientInfoInitData.identityNumber.slice(6, 7) &&
            mobileNumber === patientInfoInitData.mobile &&
            patientCode === patientInfoInitData.patientCode &&
            patientMemo === patientInfoInitData.patientMemo
        ) {
            return setButtonDisabled(true);
        }

        return setButtonDisabled(false);
    }, [gender, identityNumber, identityNumberError, patientMemo, mobileNumber, mobileNumberError, patientInfoInitData, patientName, patientCode]);

    useEffect(() => {
        if (
            (diagnosisInfoData.gradeName === '초등학교 이전 ' && semester && schoolAge + ' ' + semester !== diagnosisInfoData.gradeName) ||
            (diagnosisInfoData.gradeName !== '초등학교 이전 ' &&
                ((schoolAge === '초등학교 이전' && !semester) || (schoolAge !== '초등학교 이전' && semester)) &&
                schoolAge + ' ' + semester !== diagnosisInfoData.gradeName) ||
            selectedDoctor !== diagnosisInfoData.doctorName ||
            selectedDate !== moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD') ||
            selectedTime !== moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('A h:mm')
        ) {
            return setEditDiagnosisModalButtonDisabled(false);
        } else if (schoolAge + ' ' + semester === diagnosisInfoData.gradeName) {
            return setEditDiagnosisModalButtonDisabled(true);
        } else if (
            selectedDoctor === diagnosisInfoData.doctorName &&
            selectedDate === moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD') &&
            selectedTime === moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('A h:mm') &&
            schoolAge + ' ' + semester === diagnosisInfoData.gradeName
        ) {
            return setEditDiagnosisModalButtonDisabled(true);
        }
        return setEditDiagnosisModalButtonDisabled(true);
    }, [selectedDoctor, selectedDate, selectedTime, schoolAge, semester, isEditDiagnosisInfoModal]);

    // filtering
    useEffect(() => {
        if (selectedTLCProgram === 0) {
            setSelectedAssessment([]);
            setFilterAssessmentData(initAssessmentData);
            setOtherAssessmentData([]);
        } else {
            const filteredData = initAssessmentData?.filter((item) => item.tags.includes(programList[selectedTLCProgram]));
            const otherData = initAssessmentData?.filter((item) => !item.tags.includes(programList[selectedTLCProgram]));

            setFilterAssessmentData(filteredData);
            setOtherAssessmentData(otherData);

            setSelectedAssessment(filteredData);
        }
    }, [selectedTLCProgram, initAssessmentData]);

    // memo 변경 시 editAssessmentState를 변경하여 leaveModal을 띄우기 위한 조건
    useEffect(() => {
        if (loginData.diagnosisTap === 3 && diagnosisMemo && diagnosisMemo !== diagnosisInfoData.prescriptionMemo) {
            return setEditState(true);
        } else {
            return setEditState(false);
        }
    }, [diagnosisMemo, diagnosisInfoData.prescriptionMemo]);

    // counsel complete button click func
    const setCounselComplete = async () => {
        if (!diagnosisInfoData._id) {
            return;
        }

        const changeStatusRqData = {
            _id: diagnosisInfoData._id,
            status: DiagnosisStatus.counselComplete,
        };

        diagnosisChangeStatus(changeStatusRqData, {
            onSuccess: async () => {
                await refetchDiagnosisData();
                setIsCompleteCounselingModal();
            },
            onError: (error) => {
                console.error('상담 완료 상태 변경 실패', error);
            },
        });
    };

    // assessment filter init
    const handleResetFilter = async () => {
        if (selectedTLCProgram === 0) {
            selectedAssessment.length !== 0 && setSelectedAssessment([]);
        } else {
            setSelectedTLCProgram(0);
        }
    };

    // check box handler
    const handleCheck = (item: IDAssessment) => {
        const isItemInSelectedAssessment = selectedAssessment.some((selectedItem) => selectedItem._id === item._id);

        if (isItemInSelectedAssessment) {
            setSelectedAssessment(selectedAssessment.filter((selectedItem) => selectedItem._id !== item._id));
        } else {
            setSelectedAssessment([...selectedAssessment, item]);
        }
    };

    // all check box handler
    const handleAllCheck = (type?: string) => {
        if (type === 'filteringData') {
            if (allFilterAssessmentCheck) {
                setAllFilterAssessmentCheck(false);
                setSelectedAssessment(selectedAssessment.filter((item) => !filterAssessmentData.includes(item)));
            } else {
                setAllFilterAssessmentCheck(true);
                setSelectedAssessment([...selectedAssessment, ...filterAssessmentData]);
            }
        } else if (type === 'others') {
            if (allOtherAssessmentCheck) {
                setAllOtherAssessmentCheck(false);
                setSelectedAssessment(selectedAssessment.filter((item) => !otherAssessmentData.includes(item)));
            } else {
                setAllOtherAssessmentCheck(true);
                setSelectedAssessment([...selectedAssessment, ...otherAssessmentData]);
            }
        } else {
            if (allCheck) {
                setAllCheck(false);
                setSelectedAssessment([]);
            } else {
                setAllCheck(true);
                setSelectedAssessment([...filterAssessmentData, ...otherAssessmentData]);
            }
        }
    };

    // 환자 정보 set
    const processPatientData = () => {
        if (!patientData) return;

        const { birthDate, ageString } = calculateAge(patientData.identityNumber);

        setBirthDate(birthDate);
        setAge(ageString);
        setPatientName(patientData.name);
        setMobileNumber(patientData.mobile);
        setIdentityNumber(patientData.identityNumber.slice(0, 6));
        setGender(patientData.identityNumber.slice(6, 7));
        setPatientMemo(patientData.patientMemo);
        setPatientCode(patientData.patientCode);
        setPatientInfoInitData(patientData);
        setEditState(false);
        setReturnSelectedAssessmentState(false);
    };

    // 진료 정보 불러오기 API
    const processDiagnosisData = async () => {
        if (!diagnosisData) return;
        let newCounselDateTimeCount = 0;

        const selectedMoment = selectedDate ? moment(selectedDate, 'YYYY/MM/DD') : moment(diagnosisData.diagnosisDateTime, 'YYYYMMDDHHmm');
        const birthMoment = moment(identityNumber || diagnosisData.patientIdentityNumber, 'YYMMDD');
        const years = selectedMoment.diff(birthMoment, 'years');
        const months = selectedMoment.diff(birthMoment, 'months') - years * 12;

        // tag 추가 수정
        const addTagData = editReportTags(diagnosisData.assessmentList);

        // 상담 일시 수정 count
        diagnosisData.noShowInfo?.forEach((item) => {
            item.newCounselDateTime && newCounselDateTimeCount++;
        });

        // tag 추가된 reponse data 및 검사 나이 추가
        const addTagInResponseData = {
            ...diagnosisData,
            assessmentList: addTagData,
            assessmentAge: `만 ${years}세 ${months}개월`,
            noShowDisabled: diagnosisData.noShowInfo?.length !== 2 && diagnosisData.noShowInfo?.length === newCounselDateTimeCount ? false : true,
        };

        setDiagnosisInfoData(addTagInResponseData);
        setSelectedDoctor(diagnosisData.doctorName);
        setInitSelectedAssessment(diagnosisData.assessmentList);
        setSelectedAssessment(diagnosisData.assessmentList);
        setDiagnosisMemo(diagnosisData.prescriptionMemo);
        setInitDiagnosisMemo(diagnosisData.prescriptionMemo);
        setDoctorsIdx(loginData.doctors.findIndex((item) => item.name === diagnosisData.doctorName));
        setSelectedDate(moment(diagnosisData.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD'));
        setSelectedTime(moment(diagnosisData.diagnosisDateTime, 'YYYYMMDDHHmm').format('A h:mm'));
        processAssessmentList(diagnosisData.diagnosisDateTime, diagnosisData.patientIdentityNumber, diagnosisData.gradeCode);
    };
    // 검사 목록
    const processAssessmentList = (diagnosisDateTime: string, patientIdentityNumber: string, gradeCode: string) => {
        if (!assessmentList) return;

        const monthLived = calculateDaysLived(patientIdentityNumber, diagnosisDateTime);

        const filtertData = assessmentsFilter(assessmentList, monthLived, gradeCode);
        const resultData = editReportTags(filtertData);

        setInitAssessmentData(resultData);
        setFilterAssessmentData(resultData);
        setReturnSelectedAssessmentState(false);
    };

    // 공통 업데이트 핸들러 함수
    const handleDiagnosisUpdate = (rqData: DiagnosisUpdateReqeustType, onSuccessCallback?: () => void | Promise<void>) => {
        diagnosisUpdate(rqData, {
            onSuccess: async (data) => {
                if (onSuccessCallback) await onSuccessCallback();
                handleResetFilter();
                await refetchDiagnosisData();
            },
            onError: (error) => {
                console.error('진단 정보 업데이트 실패', error);
            },
        });
    };

    // 진료 정보 업데이트
    const updateDiagnosisInfo = async () => {
        const selectedMoment = moment(selectedDate, 'YYYY/MM/DD');
        const birthMoment = moment(identityNumber || diagnosisInfoData.patientIdentityNumber, 'YYMMDD');
        const years = selectedMoment.diff(birthMoment, 'years');
        const months = selectedMoment.diff(birthMoment, 'months') - years * 12;
        const rqData =
            getDiagnosisStatus(diagnosisInfoData) === 'reschedule'
                ? (getRqDataUpdateDiagnosisInfo() as DiagnosisUpdateReqeustType)
                : {
                      _id: diagnosisInfoData._id,
                      diagnosisDateTime: moment(selectedDate).format('YYYYMMDD') + moment(selectedTime, 'A h:mm').format('HHmm'),
                      diagnosisTimestamp: moment(selectedDate + ' ' + moment(selectedTime, 'A h:mm').format('HHmm'), 'YYYYMMDD HHmm').valueOf(),
                      doctorName: selectedDoctor,
                      gradeCode: gradeCode,
                      gradeName: `${schoolAge} ${semester}`,
                      assessmentAge: `만 ${years}세 ${months}개월`,
                  };

        const callbackFunc = async () => {
            if (diagnosisInfoData.status === 1) await clearDiagnosis(diagnosisInfoData._id);
            if (getDiagnosisStatus(diagnosisInfoData) === 'reschedule') {
                onChangeDiagnosisDateModal(diagnosisInfoData);
            } else {
                setIsEditDiagnosisInfoModal();
            }
        };

        handleDiagnosisUpdate(rqData, callbackFunc);
    };

    // 환자 정보 update
    const updatePatientInfo = () => {
        const selectedMoment = moment(selectedDate, 'YYYY/MM/DD');
        const birthMoment = moment(identityNumber || diagnosisInfoData.patientIdentityNumber, 'YYMMDD');
        const years = selectedMoment.diff(birthMoment, 'years');
        const months = selectedMoment.diff(birthMoment, 'months') - years * 12;
        const rqData = {
            _id: patientInfoInitData._id,
            name: patientName,
            mobile: mobileNumber,
            identityNumber: identityNumber + gender,
            hospitalId: patientInfoInitData.hospitalId,
            patientCode: patientCode,
            patientMemo: patientMemo,
        };
        patientUpdate(rqData, {
            onSuccess: () => {
                const updateDiagnosisRqData = {
                    _id: diagnosisInfoData._id,
                    assessmentAge: `만 ${years}세 ${months}개월`,
                };
                setIsChangePatientInfoModal();
                handleDiagnosisUpdate(
                    updateDiagnosisRqData,
                    diagnosisInfoData.status === 1
                        ? async () => {
                              await clearDiagnosis(diagnosisInfoData._id);
                          }
                        : undefined
                );
            },
            onError: (error) => {
                console.error('환자 정보 변경 실패', error);
            },
        });
    };

    // memo Update func
    const updateMemo = async () => {
        const rqData = {
            _id: diagnosisInfoData._id,
            prescriptionMemo: diagnosisMemo,
        };
        handleDiagnosisUpdate(rqData);
    };

    // 검사 결과 데이터 - query로 수정 금지
    const processResultDiagnosis = async () => {
        if (!resultDiagnosis) return;

        setComprehensiveResults(resultDiagnosis);
        const findByAssessmentCodeResults = await Promise.all(
            resultDiagnosis.map(async (item) => {
                const getAssessmentCodeResultApiCallResponse = await getAssessmentCodeResultApiCall(item.ozJsonInfoData.PSY_ITEM_ID);
                return getAssessmentCodeResultApiCallResponse?.data;
            })
        );
        setFindByAssessmentCode(findByAssessmentCodeResults.flat() as any);
    };

    // 검사 받은 항목의 상세 정보 불러오기 API
    const getAssessmentCodeResultApiCall = async (code: string) => {
        const response = await DCKAssessmentApi.getAssessmentCodeResult(code, loginData.token);

        if (response.status === 'ok') {
            console.log(response, '검사 결과 불러오기 성공');
            return response;
        } else {
            console.log('검사 결과 불러오기 실패');
        }
    };

    // 진료 지정 추가
    const handleAddAssessment = async (code: number) => {
        setLoading(true);
        try {
            const selectedAssessmentCodeList: string[] = [];
            selectedAssessment.filter((item) => selectedAssessmentCodeList.push(item.assessmentCode));
            const rqData = {
                _id: diagnosisInfoData._id,
                codeList: selectedAssessmentCodeList,
                notificationCode: String(code),
            };

            const response = await DCKAssessmentApi.addAssessment(rqData, loginData.token);
            if (response.status === 'ok') {
                setIsAddAssessmentModal();
                if (diagnosisInfoData.status === 1) {
                    handleResetFilter();
                    setEditState(false);
                    return await refetchDiagnosisData();
                } else if (diagnosisInfoData.status === 0) {
                    const rqData = {
                        _id: diagnosisInfoData._id,
                        status: 1,
                    };
                    const response = await DCKDiagnosisApi.changeDiagnosisStatus(rqData, loginData.token);

                    if (response.status === 'ok') {
                        handleResetFilter();
                        return await refetchDiagnosisData();
                    } else {
                        setLoading(false);
                        console.log('stats 변경 실패');
                    }
                }
            } else {
                setLoading(false);
                console.log('검사 지정 실패');
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    // 진료 삭제 API
    const removeDiagnosisApiCall = async () => {
        setLoading(true);
        const rqData = {
            _id: diagnosisInfoData._id,
            status: -1,
        };
        const response = await DCKDiagnosisApi.changeDiagnosisStatus(rqData, loginData.token);

        if (response.status === 'ok') {
            navigate(pagePaths.diagnosisList, { replace: true });
            setLoading(false);
        } else {
            setLoading(false);
            console.log('stats 변경 실패');
        }
    };

    // 초기 데이터 설정
    const handleInitSchooAgeAndSemester = () => {
        const findItem = (school: { school: string; semester: string; value: string }[]) => school.find((item) => item.value === diagnosisInfoData.gradeCode);

        const foundItem = findItem(primarySchool) || findItem(middleSchool) || findItem(highSchool);

        if (foundItem) {
            const schoolAgeIdx = schoolName.findIndex((item) => item === foundItem.school);
            let semesterIdx = -1;
            if (foundItem.school === '초등학교') {
                semesterIdx = primarySchool.findIndex((item) => item.semester === foundItem.semester);
            } else if (foundItem.school === '중학교') {
                semesterIdx = middleSchool.findIndex((item) => item.semester === foundItem.semester);
            } else if (foundItem.school === '고등학교') {
                semesterIdx = highSchool.findIndex((item) => item.semester === foundItem.semester);
            }
            setSchoolAge(foundItem.school);
            setSemester(foundItem.semester);
            setGradeCode(foundItem.value);
            setSchoolAgeIdx(schoolAgeIdx);
            setSemesterIdx(semesterIdx);
        } else {
            setSchoolAge('초등학교 이전');
            setSemester('');
            setGradeCode('');
            setSchoolAgeIdx(0);
        }
    };

    // 학령 / 학기 드롭다운 핸들러
    const handleSchoolAgeAndSemesterDropDown = (id: string, idx: number | undefined, name: string, value: string) => {
        if (id === 'schoolAge' && idx === 0) {
            setSchoolAge(name);
            setSemester('');
            setGradeCode('');
            setSemesterIdx(undefined);
            setOnSchoolAgeDropdown(!onSchoolAgeDropdown);
            setSchoolAgeIdx(idx);
            setErrMsg({ schoolAge: '', semester: '' });
        } else if (id === 'schoolAge' && idx !== undefined) {
            setSchoolAge(name);
            setSemester('');
            setGradeCode('');
            setSemesterIdx(undefined);
            setOnSchoolAgeDropdown(!onSchoolAgeDropdown);
            setSchoolAgeIdx(idx);
            setErrMsg((prevErrMsg) => ({ ...prevErrMsg, [id]: '필수 정보입니다. 학령과 학기 모두 선택해주세요.' }));
        } else if (id === 'schoolAge') {
            setOnSchoolAgeDropdown(!onSchoolAgeDropdown);
            setOnSemesterDropdown(false);
        } else if (id === 'semester' && idx !== undefined) {
            setSemester(name);
            setGradeCode(value);
            setOnSemesterDropdown(!onSemesterDropdown);
            setSemesterIdx(idx);
            setErrMsg((prevErrMsg) => ({ ...prevErrMsg, schoolAge: '', semester: '' }));
        } else {
            setOnSemesterDropdown(!onSemesterDropdown);
            setOnSchoolAgeDropdown(false);
        }
    };

    // 담당의 변경
    const handleDoctorData = (idx: number) => {
        setDoctorsIdx(idx);
        setSelectedDoctor(loginData.doctors[idx].name);
    };

    // 검사 변경 취소 버튼 function
    const clickCancelButtonInEditAssessment = async () => {
        await handleResetFilter();
        setSelectedAssessment(initSelectedAssessment);
        setFilterAssessmentData(initAssessmentData);
        setIsLeaveModal();
        setInit();
    };

    // 진료 목록 BreadCrumb 클릭
    const clickBreadCrumbDiagnosisList = () => {
        if (returnSelectedAssessmentState) {
            setIsReturnSelectedAssessment();
            return setClickType('breadCrumb');
        } else if (editState) {
            setClickType('breadCrumb');
            return setIsLeaveModal();
        } else {
            if (loginData.level === AccountLevel.externalCounselor) {
                return navigate(pagePaths.mindUpAdminDiagnosisList);
            }
            return navigate(pagePaths.diagnosisList);
        }
    };

    // modal 나가기 버튼
    const clickLeaveButtonInLeaveModal = () => {
        if (returnSelectedAssessmentState && clickType === 'breadCrumb') {
            setIsReturnSelectedAssessment();
            setInit();
            setLoginData({ ...loginData, diagnosisTap: 0 });
            return navigate(pagePaths.diagnosisList);
        } else if (returnSelectedAssessmentState && (clickType === 'sideBar' || clickType === 'header')) {
            setInit();
            setLoginData({ ...loginData, diagnosisTap: 0 });
            return navigate(movePath);
        } else if (clickType === 'cancel') {
            return clickCancelButtonInEditAssessment();
        } else if (clickType === 'breadCrumb') {
            setIsLeaveModal();
            setLoginData({ ...loginData, diagnosisTap: 0 });
            setInit();
            return navigate(pagePaths.diagnosisList);
        } else if (clickType === 'sideBar' || clickType === 'header') {
            navigate(movePath);
            setLoginData({ ...loginData, diagnosisTap: 0 });
            return setInit();
        }
    };

    // memo 취소 버튼
    const clickCancelButtonInMemo = () => {
        if (diagnosisInfoData.prescriptionMemo === diagnosisMemo) {
            setMemoChangeBtn(true);
        } else {
            setIsCancelMemoModal();
        }
    };

    // memo 취소 모달 나가기 버튼
    const clickCancelButtonInCancelMemoModal = () => {
        if (diagnosisMemo !== diagnosisInfoData.prescriptionMemo) {
            setDiagnosisMemo(diagnosisInfoData.prescriptionMemo || '');
            setIsCancelMemoModal();
            setLoginData({ ...loginData, diagnosisTap: temporarySelectedTap });
            if (diagnosisInfoData.prescriptionMemo) {
                setMemoChangeBtn(true);
            } else {
                setMemoChangeBtn(false);
            }
        } else {
            setDiagnosisMemo('');
            setIsCancelMemoModal();
            setMemoChangeBtn(false);
        }
    };

    // 주민등록번호 앞자리 입력 및 유효성 검사
    const handleIdentityNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIdentityNumber(e.target.value);
        const { genderCodeError } = calculateAge(e.target.value + gender);
        if (e.target.value.length > 0) {
            const valid = isValidBirthdate(e.target.value);
            if (!valid || genderCodeError) return setIdentityNumberError('주민등록번호를 정확히 입력해주세요.');
        }
        return setIdentityNumberError('');
    };

    // 주민번호 뒷자리(성별) 입력 및 유효성 검사
    const handleGenderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setGender(e.target.value);
        if (e.target.value.length > 0) {
            const { genderCodeError } = calculateAge(identityNumber + e.target.value);
            if (genderCodeError) return setIdentityNumberError('주민등록번호를 정확히 입력해주세요.');
        }
        return setIdentityNumberError('');
    };

    // mobileNumber 입력 및 유효성 검사
    const handleMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value.replace(/[^0-9]/g, '');

        setMobileNumber(newValue);
        if (newValue.length > 0 && newValue.length < 9) {
            return setMobileNumberError('연락처를 정확히 입력해주세요.');
        }
        return setMobileNumberError('');
    };

    // Blur 이벤트 핸들러, input 내용을 지운 후 Focus out을 하면 기존 데이터 자동으로 입력
    const handleBlur = (valueLength: number, setState: Dispatch<SetStateAction<string>>, value: string) => {
        if (valueLength === 0) {
            setState(value);
        }
    };

    // 환자 정보 변경 취소 버튼
    const clickCancelButtonInEditPatientInfo = () => {
        setPatientName(patientInfoInitData.name);
        setIdentityNumber(patientInfoInitData.identityNumber.slice(0, 6));
        setGender(patientInfoInitData.identityNumber.slice(6, 7));
        setMobileNumber(patientInfoInitData.mobile);
        setPatientMemo(patientInfoInitData.patientMemo);
        setPatientCode(patientInfoInitData.patientCode);
        setIdentityNumberError('');
        setMobileNumberError('');
        setIsChangePatientInfoModal();
    };

    // 진료 정보 변경 취소 버튼
    const clickCancelButtonInEditDiagnosisInfo = () => {
        handleInitSchooAgeAndSemester();
        setSelectedDoctor(diagnosisInfoData.doctorName);
        setDoctorsIdx(loginData.doctors.findIndex((item) => item.name === diagnosisInfoData.doctorName));
        setSelectedDate(moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD'));
        setSelectedTime(moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('A h:mm'));
        setIsEditDiagnosisInfoModal();
    };

    // 진료 상세보기 탭 이동
    const handleTaps = (idx: number) => {
        setTemporarySelectedTap(idx);

        if (
            loginData.diagnosisTap === 3 &&
            (diagnosisInfoData.prescriptionMemo || (!diagnosisInfoData.prescriptionMemo && diagnosisMemo !== '')) &&
            diagnosisMemo !== diagnosisInfoData.prescriptionMemo
        ) {
            return setIsCancelMemoModal();
        } else if (loginData.diagnosisTap === idx) {
            return window.location.reload();
        } else {
            return setLoginData({ ...loginData, diagnosisTap: idx });
        }
    };

    // 진료 메모 확인 모달 취소 버튼
    const DiagnosisMemoCancelButton = () => {
        setLoginData({ ...loginData, diagnosisTap: 3 });
        setIsCancelMemoModal();
    };

    // 노쇼 모달 취소 버튼
    const NoShowModalCancelButton = () => {
        setCounselReason('');
        setCheckedCall();
        setOnProfileModal();
    };

    // 노쇼 update
    const NoShowUpdate = () => {
        // const rqData = { _id: diagnosisInfoData._id, noShowInfo: [...(diagnosisInfoData.noShowInfo || []), { noShowTimestamp: diagnosisInfoData.diagnosisTimestamp, noShowReason: counselReason }] };
        const rqData = { diagnosisId: diagnosisInfoData._id, noShowInfo: [...(diagnosisInfoData.noShowInfo || []), { noShowTimestamp: Date.now(), noShowReason: counselReason }] };
        updateNoShowInfo(rqData, {
            onSuccess: async () => {
                await refetchDiagnosisData();
                NoShowModalCancelButton();
            },
        });
    };

    // 상태에 따른 progressbar modal 분기
    const handleProgressBarOnModal = () => {
        if (getDiagnosisStatus(diagnosisInfoData) === 'reschedule') return onChangeDiagnosisDateModal(diagnosisInfoData);
        if (getDiagnosisStatus(diagnosisInfoData) === 'counselReserved') return setIsCompleteCounselingModal();
        return;
    };

    return !loading ? (
        <DiagnosisLayout>
            {onDialogueScheduleModal && (
                <FillOutDialogueSchedule
                    diagnosisInfo={selectedDialogueScheduleData!}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    initDate={initDate}
                    selectedTime={selectedTime}
                    setSelectedTime={setSelectedTime}
                    onModalClose={closeFillOutDialogueScheduleModal}
                    updateDiagnosisInfoApiCall={updateDiagnosisInfo}
                    label='상담 일시'
                    title='상담 일시 변경'
                />
            )}
            {onProfileModal && (
                <ProfileDetailInfoWithInput
                    title={`노쇼 ${diagnosisInfoData.noShowInfo!.length + 1}회로 처리할까요?`}
                    firstContent={getNoShowModalContent(diagnosisInfoData).firstContent}
                    secondContent={getNoShowModalContent(diagnosisInfoData).secondContent}
                    cancelButton={NoShowModalCancelButton}
                    confirmButton={NoShowUpdate}
                    firstButton='취소'
                    secondButton='노쇼 처리하기'
                    // noShowData={diagnosisInfoData.noShowInfo}
                    name={diagnosisInfoData.patientName}
                    subText={`${calculateAge(diagnosisInfoData.patientIdentityNumber).birthDate} (${calculateAge(diagnosisInfoData.patientIdentityNumber).ageString})`}
                    gender={diagnosisInfoData.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    firstLabel='진료일시'
                    firstLabelText={moment(diagnosisInfoData.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD A h:mm')}
                    secondLabel='연락처'
                    secondLabelText={changeMobileForm(diagnosisInfoData.patientMobile)}
                    thirdLabel='주양육자'
                    thirdLabelText={
                        <ThirdLabelTextWrapper>
                            <Body4Medium>{getRelationTypeStr(diagnosisInfoData.relationType)}</Body4Medium>
                            <ColumnDivider $height='12px' />
                            <Body4Medium>{diagnosisInfoData.parentName}</Body4Medium>
                        </ThirdLabelTextWrapper>
                    }
                    setCounselReason={setCounselReason}
                    counselReason={counselReason}
                    setCheckedCall={setCheckedCall}
                    checkedCall={checkedCall}
                />
            )}
            {((loginData.diagnosisTap === 3 && isLeaveModal) || isCancelMemoModal) && (
                <DiagnosisMemoCancelConfirmModal
                    title={getCancelMemoText(loginData.level, diagnosisInfoData.prescriptionMemo).title}
                    firstContent={getCancelMemoText(loginData.level, diagnosisInfoData.prescriptionMemo).firstSubText}
                    secondContent={getCancelMemoText(loginData.level, diagnosisInfoData.prescriptionMemo).secondSubText}
                    firstButton={getCancelMemoText(loginData.level, diagnosisInfoData.prescriptionMemo).firstButton}
                    secondButton={getCancelMemoText(loginData.level, diagnosisInfoData.prescriptionMemo).secondButton}
                    setIsLeaveModal={isLeaveModal ? setIsLeaveModal : DiagnosisMemoCancelButton}
                    clickLeaveButtonInLeaveModal={isLeaveModal ? clickLeaveButtonInLeaveModal : clickCancelButtonInCancelMemoModal}
                    temporarySelectedTap={temporarySelectedTap}
                />
            )}
            {isCompleteCounselingModal && (
                <BasicConfirmModal
                    title='상담을 완료하셨나요?'
                    content='상담을 끝내셨다면, 완료 처리해주세요.'
                    cancelButton={setIsCompleteCounselingModal}
                    confirmButton={setCounselComplete}
                    firstButton='취소'
                    secondButton='상담 완료'
                />
            )}
            {isRemoveDiagnosisModal && (
                <RemoveDiagnosisModal userInfo={patientInfoInitData} diagnosisInfo={diagnosisInfoData} toggle={setIsRemoveDiagnosisModal} clickRemoveButton={removeDiagnosisApiCall} />
            )}

            {isChangePatientInfoModal && (
                <EditPatientInfoModal
                    toggle={clickCancelButtonInEditPatientInfo}
                    userInfo={patientInfoInitData}
                    birthDate={birthDate}
                    age={age}
                    patientName={patientName}
                    setPatientName={setPatientName}
                    identityNumber={identityNumber}
                    setIdentityNumber={setIdentityNumber}
                    gender={gender}
                    setGender={setGender}
                    patientCode={patientCode}
                    setPatientCode={setPatientCode}
                    mobileNumber={mobileNumber}
                    setMobileNumber={setMobileNumber}
                    patientMemo={patientMemo}
                    setPatientMemo={setPatientMemo}
                    handleBlur={handleBlur}
                    handleIdentityNumberChange={handleIdentityNumberChange}
                    identityNumberError={identityNumberError}
                    handleGenderChange={handleGenderChange}
                    handleMobileChange={handleMobileChange}
                    mobileNumberError={mobileNumberError}
                    buttonDisabled={buttonDisabled}
                    clickUpdateButton={updatePatientInfo}
                />
            )}
            {loginData.diagnosisTap === 0 && isReturnSelectedAssessment && (
                <LeaveModal
                    setIsLeaveModal={setIsReturnSelectedAssessment}
                    clickLeaveButtonInLeaveModal={clickLeaveButtonInLeaveModal}
                    title={returnSelectedAssessmentModalText.title}
                    content={returnSelectedAssessmentModalText.content}
                    firstButton={returnSelectedAssessmentModalText.firstButton}
                    secondButton={returnSelectedAssessmentModalText.secondButton}
                />
            )}
            {loginData.diagnosisTap === 0 && isLeaveModal && (
                <LeaveModal
                    setIsLeaveModal={setIsLeaveModal}
                    clickLeaveButtonInLeaveModal={clickLeaveButtonInLeaveModal}
                    title={leaveModalText.title}
                    content={leaveModalText.content}
                    firstButton={leaveModalText.firstButton}
                    secondButton={leaveModalText.secondButton}
                />
            )}
            {isAddAssessmentModal && <AddAssessmentModal editState={editState} selectedAssessment={selectedAssessment} toggle={setIsAddAssessmentModal} handleAddAssessment={handleAddAssessment} />}
            {isEditDiagnosisInfoModal && (
                <EditDiagnosisInfoModal
                    diagnosisInfo={diagnosisInfoData}
                    userInfo={patientInfoInitData}
                    birthDate={birthDate}
                    age={age}
                    handleInitSchooAgeAndSemester={handleInitSchooAgeAndSemester}
                    schoolAge={schoolAge}
                    semester={semester}
                    schoolAgeIdx={schoolAgeIdx}
                    semesterIdx={semesterIdx}
                    handleSchoolAgeAndSemesterDropDown={handleSchoolAgeAndSemesterDropDown}
                    setOnSchoolAgeDropdown={setOnSchoolAgeDropdown}
                    onSchoolAgeDropdown={onSchoolAgeDropdown}
                    setOnSemesterDropdown={setOnSemesterDropdown}
                    onSemesterDropdown={onSemesterDropdown}
                    errMsg={errMsg}
                    initDate={initDate}
                    selectedDate={selectedDate}
                    selectedTime={selectedTime!}
                    setSelectedDate={setSelectedDate}
                    setSelectedTime={setSelectedTime}
                    setDoctors={handleDoctorData}
                    doctorsIdx={doctorsIdx}
                    selectedDoctor={selectedDoctor}
                    setOnCalendar={setOnCalendar}
                    onCalendar={onCalendar}
                    buttonDisabled={editDiagnosisModalButtonDisabled}
                    // setIsEditDiagnosisInfoModal={setIsEditDiagnosisInfoModal}
                    toggle={clickCancelButtonInEditDiagnosisInfo}
                    updateDiagnosisInfoApiCall={updateDiagnosisInfo}
                />
            )}

            <DiagnosisInnerLayout>
                <TwoBreadCrumbContainer>
                    <HospitalPageLabel onClick={clickBreadCrumbDiagnosisList}>
                        {loginData.level === AccountLevel.externalCounselor ? viewDetailConsultationPageText.pageLabel : viewDetailDiagnosisPageText.pageLabel}
                    </HospitalPageLabel>
                    <IconWrapper>
                        <ArrowRightSlim />
                    </IconWrapper>
                    <HospitalPageLabel onClick={() => window.location.reload()}>
                        {loginData.level === AccountLevel.externalCounselor ? viewDetailConsultationPageText.pageTitle : viewDetailDiagnosisPageText.pageTitle}
                    </HospitalPageLabel>
                </TwoBreadCrumbContainer>
                <PageTitle $marginbottom='20px'>{loginData.level === AccountLevel.externalCounselor ? viewDetailConsultationPageText.pageTitle : viewDetailDiagnosisPageText.pageTitle}</PageTitle>
                <InfoHeaderContainer>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <DiagnosisTime $noShowDisabled={diagnosisInfoData.noShowDisabled!}>{formattedTime(diagnosisInfoData.diagnosisDateTime)}</DiagnosisTime>
                        <Body2Medium style={{ color: palette.gray }}>{getConsultationTypeStr(loginData.level)}</Body2Medium>
                    </div>
                    <InfoHeaderButtonContainer>
                        {(diagnosisInfoData.status === 0 || diagnosisInfoData.status === 1) && (
                            <>
                                <BasicButton onClick={setIsChangePatientInfoModal} $width='112px' $height='100%' $type='anotherFill'>
                                    {loginData.level === AccountLevel.externalCounselor ? viewDetailConsultationPageText.changePatientInfo : viewDetailDiagnosisPageText.changePatientInfo}
                                </BasicButton>
                                <ColumnDivider $height='24px' $backgroundcolor={palette.testGray} />
                                <BasicButton onClick={setIsRemoveDiagnosisModal} $width='84px' $height='100%' $type='anotherFill'>
                                    {loginData.level === AccountLevel.externalCounselor ? viewDetailConsultationPageText.deleteDiagnosis : viewDetailDiagnosisPageText.deleteDiagnosis}
                                </BasicButton>
                                <BasicButton onClick={setIsEditDiagnosisInfoModal} $width='112px' $height='100%' $type='anotherFill'>
                                    {loginData.level === AccountLevel.externalCounselor ? viewDetailConsultationPageText.changeDiagnosisInfo : viewDetailDiagnosisPageText.changeDiagnosisInfo}
                                </BasicButton>
                            </>
                        )}
                        {loginData.level === AccountLevel.externalCounselor && state.status === DiagnosisStatus.counselReserved && diagnosisInfoData.noShowInfo?.length !== 2 && (
                            <InfoHeaderWrapper>
                                <HoverBasicButton
                                    $type='fillLightRed'
                                    $height='36px'
                                    $width='84px'
                                    $fontSize='14px'
                                    $position='relative'
                                    hover={setIsNoShowDesc}
                                    onClick={setOnProfileModal}
                                    disabled={diagnosisInfoData.noShowDisabled!}
                                >
                                    노쇼 처리
                                    {isNoShowDesc && !diagnosisInfoData.noShowDisabled! && (
                                        <DescToolTip top='-4px' left='50%' firstDesc='노쇼 처리는 최대 2회로' secondDesc='안내에 따라 처리해주세요.' />
                                    )}
                                </HoverBasicButton>
                                <HoverBasicButton
                                    $position='relative'
                                    $type='fillLightGray'
                                    $height='36px'
                                    $width='112px'
                                    $fontSize='14px'
                                    disabled={!diagnosisInfoData.noShowDisabled!}
                                    hover={setIsChangeCounselDateDesc}
                                    onClick={() => onChangeDiagnosisDateModal(diagnosisInfoData)}
                                >
                                    상담 일시 변경
                                    {isChangeCounselDateDesc && !diagnosisInfoData.noShowDisabled! && (
                                        <DescToolTip top='-4px' left='50%' firstDesc='상담 일시 변경은' secondDesc='노쇼 처리 시에만 가능합니다.' />
                                    )}
                                </HoverBasicButton>
                            </InfoHeaderWrapper>
                        )}
                    </InfoHeaderButtonContainer>
                </InfoHeaderContainer>
                <DetailPageInfoLayout>
                    <ViewDetailDiagnosisPageInfoBody
                        userInfo={patientInfoInitData}
                        diagnosisInfo={diagnosisInfoData}
                        onClick={handleProgressBarOnModal}
                        noShowDisabled={diagnosisInfoData.noShowDisabled!}
                    />
                </DetailPageInfoLayout>
                <DiagnosisTapsContainer $topMargin='40px' $bottomMargin='36px'>
                    <TapsButtonContainer>
                        {hospitalSelectedTaps.map((item, idx) => {
                            return (
                                <DiagnosisItemButton
                                    key={idx}
                                    $idx={idx}
                                    $selected={loginData.diagnosisTap}
                                    onClick={() => handleTaps(idx)}
                                    disabled={!openTaps && diagnosisInfoData.status !== 3 && idx !== 0}
                                >
                                    {item}
                                </DiagnosisItemButton>
                            );
                        })}
                    </TapsButtonContainer>
                </DiagnosisTapsContainer>
                {loginData.diagnosisTap === 0 && (
                    <InfoBodyAssessmentList
                        diagnosisInfoData={diagnosisInfoData}
                        editState={editState}
                        selectedTLCProgram={selectedTLCProgram}
                        setSelectedTLCProgram={setSelectedTLCProgram}
                        handleResetFilter={handleResetFilter}
                        filterAssessmentData={filterAssessmentData}
                        otherAssessmentData={otherAssessmentData}
                        initAssessmentData={initAssessmentData}
                        handleCheck={handleCheck}
                        selectedAssessment={selectedAssessment}
                        handleAllCheck={handleAllCheck}
                        allCheck={allCheck}
                        allFilterAssessmentCheck={allFilterAssessmentCheck}
                        allOtherAssessmentCheck={allOtherAssessmentCheck}
                        setIsAddAssessmentModal={setIsAddAssessmentModal}
                        setEditState={setEditState}
                        setIsLeaveModal={setIsLeaveModal}
                        setClickType={setClickType}
                    />
                )}
                {loginData.diagnosisTap === 1 && (openTaps || diagnosisInfoData.status === 3) && (
                    <InfoBodyComprehensiveResults
                        diagnosisInfoData={diagnosisInfoData}
                        infoBodyComprehensiveResultsSelectedIdx={infoBodyComprehensiveResultsSelectedIdx}
                        setInfoBodyComprehensiveResultsSelectedIdx={setInfoBodyComprehensiveResultsSelectedIdx}
                        comprehensiveResults={comprehensiveResults}
                        refetchResultDiagnosis={refetchResultDiagnosis}
                    />
                )}
                {loginData.diagnosisTap === 2 && (openTaps || diagnosisInfoData.status === 3) && (
                    <InfoBodyUserResponses
                        comprehensiveResults={comprehensiveResults}
                        diagnosisInfoData={diagnosisInfoData}
                        infoBodyUserResponsesSelectedIdx={infoBodyUserResponsesSelectedIdx}
                        setInfoBodyUserResponsesSelectedIdx={setInfoBodyUserResponsesSelectedIdx}
                        findByAssessmentCode={findByAssessmentCode}
                    />
                )}
                {loginData.diagnosisTap === 3 && (openTaps || diagnosisInfoData.status === 3) && (
                    <InfoBodyDiagnosisMemo
                        setDiagnosisMemo={setDiagnosisMemo}
                        diagnosisMemo={diagnosisMemo}
                        initDiagnosisMemo={initDiagnosisMemo}
                        updateMemo={updateMemo}
                        diagnosisInfoData={diagnosisInfoData}
                        memoChangeBtn={memoChangeBtn}
                        setMemoChangeBtn={setMemoChangeBtn}
                        clickCancelButtonInMemo={clickCancelButtonInMemo}
                    />
                )}
            </DiagnosisInnerLayout>
        </DiagnosisLayout>
    ) : null;
};

export default ViewDetailDiagnosisPage;

const DiagnosisTime = styled(Body2SemiBold)<{ $noShowDisabled: boolean }>`
    display: flex;
    color: ${TextColor.color_text_neutral};
    line-height: 26px;
    gap: 4px;
    ${(props) =>
        props.$noShowDisabled &&
        `text-decoration: line-through ${TextColor.color_text_neutral};
        -webkit-text-decoration: line-through;
        text-decoration-line: line-through;
        text-decoration-style: solid;
        `};
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;

const ThirdLabelTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const InfoHeaderWrapper = styled(FlexWrapper)`
    gap: 6px;
    height: 100%;
`;

const StyledBody2Medium = styled(Body2Medium)`
    text-decoration: none !important; /* 최우선 적용 */
    color: ${TextColor.color_text_light};
`;

const settingInitPatientInfo = {
    _id: '',
    regNum: '',
    name: '',
    mobile: '',
    identityNumber: '',
    gender: '',
    hospitalId: '',
    patientCode: '',
    patientMemo: '',
    diagnosisIdList: [],
    timestamp: 0,
    updateTimestamp: 0,
    lastDiagnosisTimestamp: 0,
    status: 0,
};
